export const paymentLabels = {invoice:'Fatura',card:'Cartão de crédito',paypal:'PayPal',apple_pay:'Apple Pay',google_pay:'Google Pay'} as const;
export type ShopPaymentMethod = keyof typeof paymentLabels;
export function isOnlinePayment(method?:string):boolean {return ['card','paypal','apple_pay','google_pay'].includes(method||'');}
export function applePaySupported():boolean {
 try {
  const apple=(window as Window & {ApplePaySession?:{canMakePayments:()=>boolean}}).ApplePaySession;
  return window.isSecureContext && !!apple?.canMakePayments();
 } catch {return false;}
}
// Guest credentials stay in this browser tab, never in payment-provider return URLs.
export function savePaymentReturn(orderId:string,token?:string){
 if(!token)return;
 sessionStorage.setItem('precision-payment-return:'+orderId,JSON.stringify({token,expires:Date.now()+3600000}));
}
export function paymentReturnToken(orderId:string):string|undefined {
 try {const v=JSON.parse(sessionStorage.getItem('precision-payment-return:'+orderId)||'null');return v&&v.expires>Date.now()&&typeof v.token==='string'?v.token:undefined;}catch{return undefined;}
}
export function clearPaymentReturn(orderId:string){try{sessionStorage.removeItem('precision-payment-return:'+orderId);}catch{/* Storage may be disabled. */}}
